<template>
    <component :is="loader" v-if="loader" :detailLayout="detailLayout" :utilityData="utilityData"
               :utilityKey="utilityKey"></component>
</template>

<script>
import {defineAsyncComponent} from "vue";

export default {
    name: "UtilityDetailLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        detailLayout: '',
        utilityData: {},
        utilityKey: '',
    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.detailLayout) {
                return defineAsyncComponent(() => import('@/components/utility/layout/utilityDetail/UtilityDetailLayout.vue'));
            }
            return defineAsyncComponent(() => import(`@/components/utility/layout/utilityDetail/${this.detailLayout}.vue`))
        },
    },
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
